export default {
    name: "UserChangePassword",
    data() {
        return {
            form: {

                username: '',
                password: '',
                verifyPassword: '',
            }
        }
    },

    methods: {
        onSubmit() {
            console.log('submit!');
        }
    }
}